import * as React from 'react'
import { useMemo } from 'react'
import { IHubArgs } from '../../HubFramework/IHub'
import { HubFramework } from '../../HubFramework'
import { moduleContent } from './moduleContent'
import { DamsDataContext } from './damsDataContext'

type ModuleProps = {
  hubArgs: IHubArgs
}

export const Module: React.FC<ModuleProps> = ({ hubArgs }) => {
  const moduleContext = useMemo(() => ({ hubArgs }), [hubArgs])

  return (
    <DamsDataContext.Provider value={moduleContext}>
      <HubFramework hubContent={moduleContent} module={moduleContext} />
    </DamsDataContext.Provider>
  )
}
